export default __webpack_public_path__ + "media/chevron-right.f808da6d.svg";